// Generated by Copilot- Start - 2026-04-24 19:38:03
// Cached processed channels for lazy-load API route, keyed by chnlSrc.
// Stored on globalThis so both Express (CommonJS) and Next.js API routes (webpack-bundled)
// read from the same instance. Without this, webpack creates a separate module scope
// and the API route sees null even after the adapter populates the cache.
//
// Key space: "<chnlSrc>:<variant>"  e.g. "streamclup:genre", "streamclup:internet"
// Plain keys (e.g. "streamclup") may also be populated by server routes for backward compat.
//
// Data shape: NormalizedChannelData (pre-parsed; client reads directly — zero client parsing)
export type ChannelCacheEntry = { data: { channels: any[] } | Record<string, any> | null; serialized: string | null };

// Known channel sources from CMS. Used to validate query params before cache lookup.
export const VALID_CHANNEL_SOURCES = new Set([
  'streamclup', 'satelliteclup', 'dtvclup', 'default'
]);

declare global {

  var __channelCache: Record<string, ChannelCacheEntry> | undefined;
}

if (!globalThis.__channelCache) {
  globalThis.__channelCache = Object.create(null) as Record<string, ChannelCacheEntry>;
}
export const sharedChannelCache = globalThis.__channelCache!;
// Generated by Copilot- End - 2026-04-24 19:38:03
